/* eslint-disable no-param-reassign */
function processNestedChildren(field) {
  if (field.children && field.children.length > 0) {
    field.children.forEach((child) => {
      processNestedChildren(child);
    });
  }
}

function addChildrenRecursively(fields) {
  const fieldMap = new Map();

  fields.forEach((field) => {
    fieldMap.set(field.name, field);

    const children = fields.filter(f => f.parent === field.name);

    if (children.length > 0) {
      field.children = children;
    }
  });

  const parentFields = fields.filter(field => !field.parent);
  parentFields.forEach(processNestedChildren);

  return parentFields;
}

function createUseableMobilityOffer(mobilityOffer, mobilityFields) {
  if (!mobilityOffer && !mobilityFields) {
    return [];
  }

  const categories = new Set();

  mobilityFields.forEach((field) => {
    if (mobilityOffer) {
      field.value = mobilityOffer[field.name];
    }

    categories.add(field.category);
  });

  const mobilityFieldsWithChildren = addChildrenRecursively(mobilityFields);

  return Array.from(categories).map((category) => {
    return {
      category,
      fields: mobilityFieldsWithChildren.filter(field => field.category === category),
    };
  });
}

export {
  createUseableMobilityOffer,
};